import React from 'react';
import './App.css';
import Home from './Pages/Home'
require("typeface-ibm-plex-mono")

// essentially, we are mounting each component onto the main App.tsx, through react-router for navigation. 
function App() {
  return (
  <div className="App">
      <Home/>    
  </div>

  );
}

export default App;
